import React, { useEffect, useState } from 'react';
import {
  adminGetReports,
  fillUserAddresses,
  adminReviewAction,
  callableErrorMessage,
  confirmAction,
  userPhotoList
} from '../../../adminApi';

function ReportsPanel(props) {
  const [reports, setReports] = useState([]);
  const [users, setUsers] = useState({});
  const [selectedId, setSelectedId] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const load = () => {
    setBusy(true);
    setError('');
    adminGetReports()
      .then((result) => {
        const nextReports = (result && result.reports) || [];
        const nextUsers = (result && result.users) || {};
        setReports(nextReports);
        setUsers(nextUsers);
        setSelectedId((current) => {
          if (current && nextReports.some((report) => report.reportId === current)) {
            return current;
          }
          return nextReports[0] ? nextReports[0].reportId : '';
        });
        fillUserAddresses(nextUsers, setUsers, props.onUsersUpdated);
      })
      .catch((err) => setError(callableErrorMessage(err)))
      .finally(() => setBusy(false));
  };

  useEffect(() => {
    load();
  }, []);

  const selected = reports.find((report) => report.reportId === selectedId);
  const reported = selected ? users[selected.reported] : null;
  const reporter = selected ? users[selected.reporter] : null;
  const reportedPhoto = userPhotoList(reported)[0];
  const reporterPhoto = userPhotoList(reporter)[0];

  const runAction = (label, action) => {
    if (!selected) {
      return;
    }
    if (!confirmAction(label)) {
      return;
    }
    setBusy(true);
    setError('');
    adminReviewAction(action, [selected.reported], [selected.reportId])
      .then(() => {
        if (props.onChanged) {
          props.onChanged();
        }
        load();
      })
      .catch((err) => {
        setError(callableErrorMessage(err));
        setBusy(false);
      });
  };

  return (
    <section>
      <div className="admin-section-head">
        <div>
          <h2>Reports</h2>
          <p className="admin-muted">{reports.length} pending</p>
        </div>
      </div>
      {error ? <p className="admin-error">{error}</p> : null}
      {reports.length === 0 && !busy ? (
        <p className="admin-empty">No reports in this list.</p>
      ) : (
        <div className="admin-split">
          <div className="admin-list">
            {reports.map((report) => {
              const target = users[report.reported];
              return (
                <button
                  type="button"
                  key={report.reportId}
                  className={report.reportId === selectedId ? 'admin-list-item is-active' : 'admin-list-item'}
                  onClick={() => setSelectedId(report.reportId)}
                >
                  <strong>{target ? target.name : report.reported}</strong>
                  <p className="admin-muted">{report.reason || 'No reason'}</p>
                </button>
              );
            })}
          </div>
          {selected ? (
            <section className="admin-detail">
              <h2>Report</h2>
              <div className="admin-user">
                {reportedPhoto ? <img src={reportedPhoto.url} alt="" /> : <div className="admin-card__empty" style={{ width: 72, height: 72 }}>No photo</div>}
                <div>
                  <p className="admin-muted">Reported user</p>
                  <strong>{reported ? reported.name : selected.reported}</strong>
                  <p className="admin-muted">{selected.reported}</p>
                  {reported ? (
                    <button type="button" className="admin-btn" onClick={() => props.onPreview(reported)}>
                      Open this account
                    </button>
                  ) : null}
                </div>
              </div>
              <div className="admin-user">
                {reporterPhoto ? <img src={reporterPhoto.url} alt="" /> : null}
                <div>
                  <p className="admin-muted">Reported by</p>
                  <strong>{reporter ? reporter.name : selected.reporter}</strong>
                  <p className="admin-muted">{selected.reporter}</p>
                  {reporter ? (
                    <button type="button" className="admin-btn" onClick={() => props.onPreview(reporter)}>
                      Preview reporter
                    </button>
                  ) : null}
                </div>
              </div>
              <p>{selected.reason || 'No reason given.'}</p>
              <div className="admin-actions">
                <button
                  type="button"
                  className="admin-btn admin-btn--primary"
                  disabled={busy}
                  onClick={() => runAction('Dismiss this report?', 'verify')}
                >
                  Dismiss report
                </button>
                <button
                  type="button"
                  className="admin-btn admin-btn--danger"
                  disabled={busy}
                  onClick={() => runAction('Block the reported user?', 'block')}
                >
                  Block user
                </button>
              </div>
            </section>
          ) : (
            <p className="admin-empty">Pick a report to review it.</p>
          )}
        </div>
      )}
      {busy ? <p className="admin-muted">Working…</p> : null}
    </section>
  );
}

export default ReportsPanel;
